import {checkEmail, checkMobile, checkPhone} from '@/utils/validate'

export default {
  props: {
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    property: {
      immediate: true,
      handler(val) {
        if(this.extraRules) {
          // console.log('合并 rules')
          this.rules = Object.assign(this.rules, this.extraRules)
        }
      }
    }
  },
  data() {
    const checkRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { field, message } = rule
      // const message = messageType == 'select'? this.$t('placeholder.select'): this.$t('placeholder.input')
      const messageResult = message || '请输入'
      // 一個用於組件内，一個用於父組件
      const require = this.isRequired && this.requireValid
      if(require && !valueResult) {
        callback(new Error(messageResult))
      }
      callback()
    }
    return {
      requireValid: true,
      rules: {
        input: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],
        select: [
          { required: true, message: '请选择', trigger: ['change', 'blur'] }
        ],
        select_multiple: [
          { required: true, message: '请选择', trigger: ['blur'] }
        ],
        upload: [
          { required: true, message: '请上传', trigger: ['blur','change'] }
        ],
        isrd_lst_nm: [
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],
        isrd_fst_nm: [
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],

        id_no: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        mobile_no: [
          { validator: checkMobile, trigger: ['blur'] },
          // { validator: checkRequired, trigger: ['change', 'blur'] },
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],
        phone_no: [
          { validator: checkPhone, trigger: ['blur'] },
          // { validator: checkRequired, trigger: ['change', 'blur'] },
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],

        name: [
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: true, message: '请输入', trigger: ['change', 'blur'] },
        ],
        phone: [
          { validator: checkPhone, trigger: ['blur'] },
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: true, message: '请输入', trigger: ['change', 'blur'] },
          // { pattern:/^[456789]\d{7}$/, message: '目前只支持中國香港的手機號碼' }

        ],
        email: [
          { required: false,  trigger: ['change', 'blur'] },
          { validator: checkEmail, trigger: ['change', 'blur'] },
          // { validator: checkRequired, trigger: ['change', 'blur'] },

          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],

        isrd_com_nm: [
          { pattern: /^[a-zA-Z0-9][\w \&\'\(\)\,\.\-]{0,59}$/, message: '请输入'},
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],
        contact_nm: [
          { validator: checkRequired, trigger: ['change', 'blur'] },
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],
        contact_phone: [
          // { validator: checkRequired, trigger: ['change', 'blur'] },
          { required: true, message: '请输入', trigger: ['blur'] },
          { validator: checkMobile, trigger: ['blur'] },
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        contact_email: [
          { validator: checkEmail, trigger: ['blur'] },
          { required: true, message: '请输入', trigger: ['blur'] },
        ],


        contact_no: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],

        isrd_nm: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] }
        ],


      }
    }
  }
}
